import React, { memo } from 'react';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';

const Filters = () => {

    const dispatch = useAppDispatch();

    const sharpness = useAppSelector(store => store.form.sharpness);
    const smoothness = useAppSelector(store => store.form.smoothness);

    return (
        <div>
            <label className="mr-4">
                <input
                    type="checkbox"
                    className="mr-2"
                    checked={ sharpness === 1}
                    onChange={ evt => {
                        const isChecked = evt.target.checked;

                        dispatch(
                            formActions.main({
                                sharpness: isChecked ? 1 : 0,
                            })
                        );
                    }}
                />
                <span>Sharper</span>
            </label>

            <label className="mr-4">
                <input
                    type="checkbox"
                    className="mr-2"
                    checked={ smoothness === 1 }
                    onChange={ evt => {
                        const isChecked = evt.target.checked;

                        dispatch(
                            formActions.main({
                                smoothness: isChecked ? 1 : 0,
                            })
                        );
                    }}
                />
                <span>Smoother</span>
            </label>
        </div>
    )
};

export default memo(Filters);